// UserContext.js
import { createContext, useState, useContext, useEffect } from "react";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(() => {

    const savedUser = localStorage.getItem("user");
    return savedUser ? JSON.parse(savedUser) : null;

  });

  useEffect(() => {
    if (user) {
      localStorage.setItem("user", JSON.stringify(user));
    } else {
      localStorage.removeItem("user");
    }
  }, [user]);

  const authFetch = async (url, options = {}) => {
    const token = user?.access_token || user?.token;

    const headers = {
      ...options.headers,
      'Accept': 'application/json',
    };

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(url, {
      ...options,
      headers,
    });

    if (response.status === 401) {
      // Token expired or invalid
      setUser(null);
      localStorage.removeItem("user");
      window.location.href = "/";
    }

    return response;
  };

  const refreshUser = async () => {
    if (!user) return;
    try {
      const res = await authFetch("/api/profile");
      const data = await res.json();
      if (res.ok && data.ok) {
        setUser(prev => ({ ...prev, ...data }));
      }
    } catch (e) {
      console.error("Erreur refreshUser:", e);
    }
  };

  return (
    <UserContext.Provider value={{ user, setUser, authFetch, refreshUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
